<template>
  <div>
    <v-layout wrap class="fullWindowHeight">
      <v-flex xs12 sm6>
        <v-layout wrap align-center justify-center class="fullWindowHeight">
          <v-flex xs8 style="padding-bottom: 10vh" :class="{ 'mb-3' : isPending}">
            <h1>{{ $t('f') }}</h1>
            <div>{{ $t('g') }}</div>
            <v-form ref="form" @submit.prevent="login" v-model="isFormValid" class="mt-8">
              <v-text-field v-model="email" outlined type="email" :label="$t('h')" :rules="[emailRules]" :disabled="isPending"/>
              <v-text-field v-model="password" outlined type="password" :label="$t('i')" :rules="[passwordRules]" :disabled="isPending"/>
              <v-layout wrap>
                <v-flex xs12 sm6 pt-2>
                  <v-progress-linear v-if="isPending" indeterminate class="mt-3 mb-1"/>
                  <v-btn v-else type="submit" class="secondary" :disabled="(isPending || !isFormValid) && !formHasNotBeenTouchedYet">{{ $t('j') }}</v-btn>
                  <div v-if="errorMessage" class="red--text mt-5">{{errorMessage}}</div>
                </v-flex>
                <v-flex xs12 sm6 text-right :class="{'mt-12': $vuetify.breakpoint.xs}">
                  <div>
                    <router-link :to="'/reset-password-send-email'+ langParamStr" style="text-decoration: none"><small>{{ $t('k') }}</small></router-link>
                  </div>
                  <div class="mt-1">
                    <router-link :to="'/consultant'+ langParamStr" style="text-decoration: none"><small>{{ $t('l') }}</small></router-link>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 class="greyBackground">
        <v-layout wrap class="fullWindowHeight" align-center>
          <v-flex xs12 text-center style="padding-bottom: 5vh">
            <img :src="images.main" :height="$vuetify.breakpoint.xs ? null : '450px'" class="img-horizontal-flip">
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    email: null,
    password: null,
    isFormValid: false,
    errorMessage: '',
    isPending: false,
    images: {
      main: require('@/assets/app/images/artificial_intelligence_flatline1.svg')
    },
    formHasNotBeenTouchedYet: true
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
    langParamStr() {
      const lang = this.$route.query.lang
      if (lang && lang !== 'fr') {
        return `?lang=${lang}`
      }
      return ''
    }
  },
  methods: {
    emailRules(v) {
      if (!v) return this.$t('c')
      if (!/.+@.+\..+/.test(v)) return this.$t('d')
      return true
    },
    passwordRules(v) {
      if (!v) return this.$t('e')
      return true
    },
    async login() {
      if (this.formHasNotBeenTouchedYet) return;
      this.isPending = true
      this.errorMessage = '';

      const { isUserExisting, isConsultant } = (await this.$functions.httpsCallable('isUserExisting')({ email: this.email })).data
      if (isUserExisting && isConsultant) {
        const urlBase = `${window.location.hostname === 'localhost' ? 'http' : 'https'}://${window.location.host}`
        const url = new URL(`${urlBase}/consultant`)
        if (this.email) url.searchParams.set('email', this.email);
        if (this.$route.query.lang) url.searchParams.set('lang', this.$route.query.lang);
        return this.$router.push(url.href.replace(urlBase, ''));
      }
      
      this.$auth.signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.redirectWhenUserDataIsLoaded()
        })
        .catch(err => {
          this.errorMessage = err.message;
          if (err.code === 'auth/wrong-password') this.errorMessage = this.$t('a');
          if (err.code === 'auth/user-not-found') this.errorMessage = this.$t('b');
          this.isPending = false
        });
    },
    redirectWhenUserDataIsLoaded() {
      if (this.user.data && this.user.data.createdAt && this.user.loggedIn) {
        if (this.user.data.isConsultant) return this.$router.push('/consultant/dossiers')
        else return this.$router.push('/dossiers')
      } else {
        setTimeout(() => this.redirectWhenUserDataIsLoaded(), 10)
      }
    }
  },
  watch: {
    email: {
      handler() {
        this.formHasNotBeenTouchedYet = false
      }
    },
    password: {
      handler() {
        this.formHasNotBeenTouchedYet = false
      }
    }
  },
}
</script>




<i18n>
{
  "fr": {
    "a": "Mot de passe invalide.",
    "b": "Aucun compte existant ne correspond à cette adresse email.",
    "c": "Votre adresse email est requise.",
    "d": "Votre adresse email doit être au bon format.",
    "e": "Votre mot de passe est requis.",
    "f": "Connectez-vous",
    "g": "Faites travailler notre IA.",
    "h": "Adresse email",
    "i": "Mot de passe",
    "j": "Se connecter",
    "k": "Mot de passe oublié ?",
    "l": "Vous êtes un consultant ?"
  },
  "en": {
    "a": "Your password is incorrect.",
    "b": "The email address you've provided does not match an existing member account.",
    "c": "Your email address is required.",
    "d": "Your email address must be in an appropriate format.",
    "e": "Your password is required.",
    "f": "Log in",
    "g": "Have our AI work for you.",
    "h": "Email address",
    "i": "Password",
    "j": "Log in",
    "k": "Forgot password ?",
    "l": "You are a consultant ?"
  }
}
</i18n>